import { memo } from "react";
import type { NavigationMenuLinkProps as RadixNavigationMenuLinkProps } from "@radix-ui/react-navigation-menu";
import { NavigationMenuLink } from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";
import Link, { LinkProps } from "next/link";
import { ChevronRight } from "lucide-react";

export type NavigationSubmenuItemProps = {
  isActive?: boolean;
  ref?: React.Ref<HTMLAnchorElement | null>;
} & RadixNavigationMenuLinkProps &
  React.ComponentPropsWithoutRef<"a"> &
  LinkProps;

const NavigationSubmenuItem = ({
  className,
  href = "#",
  ref,
  isActive,
  title,
  children,
  ...rest
}: NavigationSubmenuItemProps) => {
  return (
    <div>
      <NavigationMenuLink asChild>
        <Link
          href={href}
          passHref
          ref={ref}
          className={cn(
            "grid grid-cols-[1fr] flex-row items-center group select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none",
            {
              "!bg-[#E9F1FF]": isActive,
              "hover:!bg-none hover:!bg-transparent": !isActive,
            },
            className
          )}
          {...rest}
        >
          <span className="flex flex-col gap-2">
            <span
              className={cn(
                "flex w-full items-center !rounded-[0] h-10 gap-2 text-[16px] font-medium leading-none",
                { "text-blue": isActive },
                className
              )}
            >
              <span className="flex basis-4/5">{title}</span>
              <span className="flex justify-end basis-1/5">
                <ChevronRight
                  className={cn(
                    "!w-6 !h-6",
                    !isActive ? "text-black" : "text-text-blue",
                    className
                  )}
                />
              </span>
            </span>
          </span>
        </Link>
      </NavigationMenuLink>
    </div>
  );
};

export default memo(NavigationSubmenuItem);
